import React from "react";

const MobileViewLayout = ({ children }) => {
  return <div className="mobile-view">{children}</div>;
};

export default MobileViewLayout;
